import { FC } from 'react';
import { useIsRouteBetaFeatureEnabled } from '@/entities/beta-feature';
import { useHasAnyPermission } from '@/entities/profile';
import { useIsSidebarCollapsed } from '@/shared/hooks';
import { RouteConfig } from '@/shared/lib';
import { SidebarNavItem } from '@/shared/ui';
import { useIsActive } from '@/widgets/MainLayout/model/hooks/useIsActive';
import { AppSidebarLabel } from './AppSidebarLabel';
import { RouteNavIcon } from './RouteNavIcon';
import { SidebarFlyoutMenu } from './SidebarFlyoutMenu';

type Props = {
  route: RouteConfig;
  className?: string;
  /** Корневой пункт меню — только для таких в свёрнутом виде показывается меню-подсказка с названием */
  isRoot?: boolean;
};

export const AppSidebarItem: FC<Props> = (props) => {
  const { route, className, isRoot } = props;

  const { isActive } = useIsActive(route);
  const isCollapsed = useIsSidebarCollapsed();

  const allowView = useHasAnyPermission([route.viewPermission]);
  const isBetaFeatureEnabled = useIsRouteBetaFeatureEnabled(route.betaFeature);

  if (!allowView || !isBetaFeatureEnabled) {
    return null;
  }

  const navItem = (
    <SidebarNavItem
      path={route.navbar?.path || route.path!}
      isActive={isActive}
      className={className}
      icon={<RouteNavIcon route={route} />}
      label={<AppSidebarLabel label={route.label} />}
    />
  );

  if (isRoot && isCollapsed) {
    return <SidebarFlyoutMenu title={<AppSidebarLabel label={route.label} />}>{navItem}</SidebarFlyoutMenu>;
  }

  return navItem;
};
